// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"80041820","455":"fbd08c12","492":"80041820","730":"80041820","977":"3cdad411"}[chunkId] + ".chunk.js";
};